import React from 'react';
import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../../theme';
import { mediaQuery, LinkButton } from '../../common';
import { InfoCard } from './index';
import BackgroundImageMobile from '../../../img/shutterstock_55184455_ppcc.jpg';
import BackgroundImage from '../../../img/shutterstock_12763744_ppcc.jpg';

const PublicHome = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQuery.medium`
    height: 100%;
    `};
`;

const SignUpSection = styled.div`
  align-items: center;
  background-image: url('${BackgroundImageMobile}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex: 1;
  height: calc(100vh - ${appTheme.sizing.headerHeight});
  justify-content: center;
  position: relative;

  ${
    /* sc-custom '@media'*/ mediaQuery.large`
    background-image: url('${BackgroundImage}');
    background-position: center center;
    height: auto;
  `
  };
`;

const SignUpButton = styled(LinkButton)`
  margin: 2em 0;

  ${mediaQuery.large`
    bottom: 2em;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
    width: ${em('150px')};
`};
`;

const AppInfoSection = styled.div`
  ${mediaQuery.medium`
    display: flex;
    flex-direction: row;
  `};
`;

function PublicHomePage() {
  return (
    <PublicHome>
      <SignUpSection>
        <SignUpButton
          color="primary"
          size="large"
          to="/signup"
          variant="contained"
        >
          Sign Up
        </SignUpButton>
      </SignUpSection>
      <AppInfoSection>
        <InfoCard title="Location-Based Services">
          (The) Lightning Bug App uses your location to remind you to change or
          share important information about your child's health. So, next time
          you're idle in the doctor's office, (The) Lightning Bug App can send
          you a helpful reminder about recent changes in care. Or, next time
          you're at the pharmacy, (The) Lightning Bug App can help you to
          remember to track changes in medicine dosage.
        </InfoCard>
        <InfoCard title="Track Medicines, Doctors, and Appointments">
          (The) Lightning Bug App puts all of your child's changing information
          in one place. Connect appointments to reminders to share information
          with your healthcare providers. Document changes in dosage and set
          reminders on your Google or Apple integrated calendar.
        </InfoCard>
        <InfoCard title="A Purposeful Digital Assistant">
          (The) Lightning Bug App learns from your interactions with
          notifications and information that you input to create an noninvasive
          but purposely useful digital assistant.
        </InfoCard>
      </AppInfoSection>
    </PublicHome>
  );
}

export default PublicHomePage;



// WEBPACK FOOTER //
// ./src/modules/PublicHomePage/components/PublicHomePage.js